// extracted by mini-css-extract-plugin
export default {"ReportHeader":"styles_ReportHeader__UdR3w","container":"styles_container__2KgzV","menu":"styles_menu__Z9ehI"};